export class ContratoDocumentoFormModel {
    constructor(
        public documento: string = ''
    ) { }
}